module.exports = __webpack_public_path__ + "static/media/gift_tracker.58ad9fce.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@zola/zola-ui/src/assets/images/icons/gift_tracker.svg
// module id = 2083
// module chunks = 70